import { SVGProps } from 'react'

export const ArrowBack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36" {...props}>
    <rect width="36" height="36" fill="currentColor" fillOpacity="0.08" rx="18"></rect>
    <path
      fill="currentColor"
      d="M23.66 17.171H14.35l4.067-4.067a.84.84 0 000-1.183.83.83 0 00-1.175 0l-5.492 5.492a.83.83 0 000 1.175l5.492 5.491a.83.83 0 101.175-1.175l-4.067-4.066h9.308a.836.836 0 00.834-.834.836.836 0 00-.834-.833z"
    ></path>
  </svg>
)
